// Última modificación: 27/10/2025

/**
 * Dataset status
 * @default "ACTIVE"
 */
export enum DatasetFilterDtoV2StatusEnum {
	ACTIVE = "ACTIVE",
	DELETED = "DELETED",
	BOTH = "BOTH",
}
